import React from 'react';
import Box from '@mui/material/Box';
import { IconButton, TextField, Tooltip } from '@mui/material';
import { MobileTimePicker } from '@mui/x-date-pickers';
import {
	LocalizationProvider,
	MobileDateTimePicker,
} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { ClearIcon } from 'components/icons';

interface CheckpointTimeResponseProps {
	startTime: Date | null;
	onUpdateTime: (updatedTime: any) => void;
}

const CheckpointTimeResponse: React.FC<CheckpointTimeResponseProps> = (
	props,
) => {
	// Implement the TimeResponse component logic here
	const { startTime, onUpdateTime } = props;

	return (
		<Box sx={{ display: 'flex', gap: '0.5rem' }}>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				<MobileTimePicker
					value={startTime || null}
					onChange={(newTime) => onUpdateTime(newTime)}
					inputFormat="h:mm a" // Format for time
					mask="__:__ _M"
					renderInput={(params) => <TextField {...params} />}
				/>

				{/* <MobileDateTimePicker
					value={startTime || null}
					onChange={(newTime) => onUpdateTime(newTime)}
					inputFormat="EEE dd MMMM h:mm a" // Updated format
					mask="___ __ ______ __:__ _M"
					maxDateTime={new Date()}
					renderInput={(params) => <TextField {...params} />}
				/> */}
			</LocalizationProvider>
			<Box>
				<Tooltip title="Set to current time">
					<IconButton onClick={() => onUpdateTime(new Date())}>
						<AccessTimeIcon />
					</IconButton>
				</Tooltip>
				<Tooltip title="Clear time">
					<IconButton onClick={() => onUpdateTime(null)}>
						<ClearIcon />
					</IconButton>
				</Tooltip>
			</Box>
		</Box>
	);
};

export default CheckpointTimeResponse;
